module.exports = __webpack_public_path__ + "static/media/bg.d7259da8.jpg";